import { useEffect, useState, useCallback } from 'react';

import { truncateTextByWords } from '../../../utils/truncate/truncate';
import { useWindowResize } from '../../../hooks';

import { UseTruncatedParams, UseTruncateResult } from './Cut.types';

export const useTruncate = ({ contentRef, expanded, maxLines, content }: UseTruncatedParams): UseTruncateResult => {
    const [truncatedContent, setTruncatedContent] = useState<string | null>(null);
    const [needsTruncation, setNeedsTruncation] = useState(false);

    const calculateTruncation = useCallback(() => {
        if (!contentRef.current) {
            return;
        }

        const element = contentRef.current;
        const truncated = truncateTextByWords(content, element, maxLines);

        // Всегда обновляем needsTruncation, чтобы знать, нужна ли кнопка
        setNeedsTruncation(Boolean(truncated));
        setTruncatedContent(expanded || !truncated ? null : truncated);
    }, [contentRef, expanded, content, maxLines]);

    useEffect(calculateTruncation, [calculateTruncation]);

    useWindowResize(calculateTruncation);

    return { truncatedContent, needsTruncation };
};
